import { AfterViewInit, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Router } from '@angular/router';
import { TranslateService, Translation } from '@ngx-translate/core';
import {assets, PROJECTS} from '@core/constants';

@UntilDestroy()
@Component({
  selector: 'ncp-login',
  imports: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit, AfterViewInit {
  loginUrl: string = `${environment.bff_url}${environment.paths.bff}/login?returnUrl=/?s=true`;
  protected readonly router = inject(Router);
  private readonly translate = inject(TranslateService);
  protected translations!: Translation;
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  protected readonly heroImagePath = assets.img.home.home.src;

  ngOnInit(): void {
    this.translations = this.translate.instant('login');
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('login');
    });
  }

  ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  doLogin() {
    window.location.href = this.loginUrl;
  }

  protected readonly environment = environment;
  protected readonly PROJECTS = PROJECTS;
}
